import React from 'react';
export const Testimonials = () => {
  return <section className="py-6 sm:py-8" data-id="element-264">
      <h2 className="text-2xl font-bold text-indigo-900 mb-5" data-id="element-265">Real Results</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 sm:gap-6" data-id="element-266">
        <div className="bg-gray-50 p-5 sm:p-6 rounded-md" data-id="element-267">
          <div className="flex items-start mb-4" data-id="element-268">
            <div className="w-10 h-10 sm:w-12 sm:h-12 overflow-hidden rounded-full mr-3 sm:mr-4 flex-shrink-0" data-id="element-269">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3xScxA6EqH9kLmkiUJm9K2/images.jpg" alt="Linda R." className="w-full h-full object-cover" data-id="element-270" />
            </div>
            <div data-id="element-271">
              <h4 className="font-bold" data-id="element-272">Linda R., Age 52</h4>
            </div>
          </div>
          <p className="italic text-sm sm:text-base" data-id="element-273">
            "After 6 weeks, I realized I hadn't had a hot flash in three days.
            By month three, my anxiety was gone and I'd lost 8 pounds without
            trying."
          </p>
        </div>
        <div className="bg-gray-50 p-5 sm:p-6 rounded-md" data-id="element-274">
          <div className="flex items-start mb-4" data-id="element-275">
            <div className="w-10 h-10 sm:w-12 sm:h-12 overflow-hidden rounded-full mr-3 sm:mr-4 flex-shrink-0" data-id="element-276">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vV2dFhFDmGFf9t5DYCJKt6/Pretty-Beach.jpg" alt="Carol T." className="w-full h-full object-cover" data-id="element-277" />
            </div>
            <div data-id="element-278">
              <h4 className="font-bold" data-id="element-279">Carol T., Age 54</h4>
            </div>
          </div>
          <p className="italic text-sm sm:text-base" data-id="element-280">
            "I sleep through the night now. ALL NIGHT. It's like getting my life
            back."
          </p>
        </div>
        <div className="bg-gray-50 p-5 sm:p-6 rounded-md" data-id="element-281">
          <div className="flex items-start mb-4" data-id="element-282">
            <div className="w-10 h-10 sm:w-12 sm:h-12 overflow-hidden rounded-full mr-3 sm:mr-4 flex-shrink-0" data-id="element-283">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2qNsjPfC6J5NZZJTaBqDR1/40_Billion_CFU_Probiotics_Supports_gut_health_2B_immune_function_%287%29.png" alt="Patricia M." className="w-full h-full object-cover" data-id="element-284" />
            </div>
            <div data-id="element-285">
              <h4 className="font-bold" data-id="element-286">Patricia M., Age 48</h4>
            </div>
          </div>
          <p className="italic text-sm sm:text-base" data-id="element-287">
            "My brain fog lifted and I feel sharp and confident again."
          </p>
        </div>
      </div>
    </section>;
};